export default __webpack_public_path__ + "static/media/apple-store.76a5625d.svg";